import { reactive } from 'vue';
import { createGlobalState, useSessionStorage } from '@vueuse/core';

const defaults = () => ({
  static: {
    seasonFrom: null,
    seasonTo: null,
    selectedDatesRange: [],
    team: '',
    gameType: null,
  },
  dynamic: {},
});

// Shared across all components in the SPA.

export const useFiltersStore = (type='profile') => {

  function ensure(id) {
    ensureStorage(id, 'static');
    ensureStorage(id, 'dynamic');
  }

  const ensureStorage = (id, key) => {
    const storageKey = `${key}-${type}-${id}`;
    const stored = useSessionStorage(storageKey, defaults()[key]);
    return stored;
  };

  function getStatic(id) {
    return ensureStorage(id, 'static').value;
  }

  function getDynamic(id) {
    return ensureStorage(id, 'dynamic').value;
  }

  function resetDynamic(id) {
    let storage = ensureStorage(id, 'dynamic');
    storage.value = {};
  }

  return {
    ensure,
    getStatic,
    getDynamic,
    resetDynamic,
  };
};
